<template>
  <section>
    <div class="row mt-4 mb-3">
      <div class="col text-center d-flex align-items-center justify-content-center">
        <div class="loading-infinity py-2 px-4 border border-2 rounded-pill shadow-sm" >
          <svg class="fa-spin primary-svg-loading me-1" width="50" height="50" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="54" fill="none" stroke="#e6e6e6" stroke-width="8" />
            <circle cx="60" cy="60" r="54" fill="none" stroke="#ED3426" stroke-width="8" style="stroke-dasharray: 339.292;stroke-dashoffset: 130;" />
          </svg>
          <img src="~images/bodegas/Iconos/check@2x.png" alt="" width="50" class="me-1 d-none check-step-image">
          <span class="fs-5 calculate-item-text">Calculando {{ steps[currentStep] }}</span>
        </div>
      </div>
    </div>

    <div class="row mt-1">
      <div class="col d-flex">
        <ul class="list-unstyled mx-auto d-inline-block">
          <li v-for="(step, index) in steps" :key="index" class="my-2" :class="opacityStep(index)">
            <img src="~images/bodegas/Iconos/check@2x.png" alt="" height="20" class="me-1">
            <span class="fs-6">{{ step }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import segmentTrack from '../../../../common/mixins/segmentTrack'

export default {
  mixins: [segmentTrack],

  data() {
    return {
      currentStep: 0,
      steps: ['Tamaño', 'Ubicación', 'Fecha', 'Precio']
    };
  },

  computed: {
    stepsLoaded() {
      return this.steps.filter((step, index) => index <= this.currentStep);
    },

    opacityStep() {
      return (index) => {
        return this.stepsLoaded.includes(this.steps[index]) ? 'opacity-100' : 'opacity-0';
      }
    }
  },

  methods: {
    changeStep() {
      const nextStep = this.currentStep + 1;

      if (nextStep > this.steps.length - 1) return;

      this.currentStep = nextStep;

      setTimeout(this.changeStep, 1250);
    },

    changeImage() {
      const loading = document.querySelector('.primary-svg-loading');
      const check = document.querySelector('.check-step-image');

      loading.classList.toggle("d-none")
      check.classList.toggle("d-none")

      if (this.currentStep + 1 > this.steps.length - 1) return;

      setTimeout(this.changeImage, 625);
    }
  },

  mounted() {
    setTimeout(this.changeStep, 1250);
    setTimeout(this.changeImage, 625);
    this.sendSegmentTrack('MEXICAN_WAREHOUSE_BOT_SEGMENT_PUBLIC', 'Mexican Warehouse Rental Bot', 'Loading Step');

    window.uetq = window.uetq || [];
    window.uetq.push('event', 'submit_lead_form', {});
  }
}
</script>

<style scoped>
  @media (max-width: 991px) {
    .calculate-item-text{
      font-size: 1rem !important;
    }
  }
</style>
